import { useContext } from 'react';
import '../tab-nav/tab-nav.scss';
import classNames from 'classnames';
import { Link, useMatch } from 'react-router-dom';
import { TenantContext } from '../../context/tenant-context';
import { Divider } from '../divider/divider';

export const RouteTabs = ({ tabNames, path }: { tabNames: string[]; path: string }) => {
  const { contextPath } = useContext(TenantContext);
  const match = useMatch(`${contextPath}manager${path}/:tab`);
  const selectedTab = match?.params.tab;

  return (
    <div className="tab-nav">
      <nav className="tabs !px-4">
        {tabNames.map((tab, i) => (
          <Link
            to={tab.toLowerCase()}
            key={i}
            className={classNames('tab !py-3', {
              selected: selectedTab && selectedTab.localeCompare(tab, undefined, { sensitivity: 'accent' }) === 0,
            })}
          >
            {tab}
          </Link>
        ))}
      </nav>

      <Divider />
    </div>
  );
};
